import { useState } from 'react';

export const useStepper = <const T extends readonly string[]>(steps: T) => {
  const [index, setIndex] = useState(0);

  return {
    step: steps[index] as T[number],
    next: () => setIndex((i) => Math.min(i + 1, steps.length - 1)),
    goTo: (s: T[number]) => setIndex(steps.indexOf(s)),
  };
};
